import moment from 'moment'
export const monthMap = {
    '1': 'Jan',
    '2': 'Feb',
    '3': 'Mar',
    '4': 'Apr',
    '5': 'May',
    '6': 'Jun',
    '7': 'Jul',
    '8': 'Aug',
    '9': 'Sep',
    '10': 'Oct',
    '11': 'Nov',
    '12': 'Dec',
};
export const dateConfig = {
    'year': {
        format: 'YYYY',
        caption: 'Year',
        step: 1,
    },
    'month': {
        format: value => monthMap[value.getMonth() + 1],
        caption: 'Month',
        step: 1,
    },
    'date': {
        format: 'DD',
        caption: 'Day',
        step: 1,
    },
};

export const groupFBSbyCatagory = (fbsList) => {
    let result = []
    if (fbsList && fbsList.length > 0) {
        fbsList.forEach(element => {
            const { fbCategoryId } = element
            const { name, _id } = fbCategoryId ? fbCategoryId : null
            let findIndexCategory = result.findIndex(r => r.fbCategoryId === _id)
            if (findIndexCategory > -1) {
                let data = result[findIndexCategory].data
                result[findIndexCategory].data = data.concat(element)
            } else result.push({ fbCategoryId: _id, name: name, data: [element] })
        });
    }
    return result
}


// WEBPACK FOOTER //
// ./src/lib/constant.js